// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";

function PlaceOrderStepsController(Props) {
  var currentStep = Props.currentStep;
  var match = React.useState(function () {
        return "";
      });
  var setPickupStepClass = match[1];
  var match$1 = React.useState(function () {
        return "";
      });
  var setVehicleStepClass = match$1[1];
  var match$2 = React.useState(function () {
        return "";
      });
  var setPlaceOrderStepClass = match$2[1];
  React.useEffect((function () {
          switch (currentStep) {
            case /* PickupDropStep */0 :
                Curry._1(setPickupStepClass, (function (param) {
                        return "steps_active";
                      }));
                Curry._1(setVehicleStepClass, (function (param) {
                        return "";
                      }));
                Curry._1(setPlaceOrderStepClass, (function (param) {
                        return "";
                      }));
                break;
            case /* VehicleSelectionStep */1 :
                Curry._1(setPickupStepClass, (function (param) {
                        return "steps_completed";
                      }));
                Curry._1(setVehicleStepClass, (function (param) {
                        return "steps_active";
                      }));
                Curry._1(setPlaceOrderStepClass, (function (param) {
                        return "";
                      }));
                break;
            case /* ConfirmOrderStep */2 :
                Curry._1(setPickupStepClass, (function (param) {
                        return "steps_completed";
                      }));
                Curry._1(setVehicleStepClass, (function (param) {
                        return "steps_completed";
                      }));
                Curry._1(setPlaceOrderStepClass, (function (param) {
                        return "steps_active";
                      }));
                break;
            
          }
          
        }), [currentStep]);
  return React.createElement("div", {
              className: "steps-controller-container"
            }, React.createElement("div", {
                  className: "steps " + match[0]
                }, React.createElement("div", {
                      className: "key"
                    }, "1"), React.createElement("div", {
                      className: "label"
                    }, "Pick Up and Drop")), React.createElement("div", {
                  className: "step-line"
                }), React.createElement("div", {
                  className: "steps " + match$1[0]
                }, React.createElement("div", {
                      className: "key"
                    }, "2"), React.createElement("div", {
                      className: "label"
                    }, "Vehicle Selection")), React.createElement("div", {
                  className: "step-line"
                }), React.createElement("div", {
                  className: "steps " + match$2[0]
                }, React.createElement("div", {
                      className: "key"
                    }, "3"), React.createElement("div", {
                      className: "label"
                    }, "Confirm Order")));
}

var make = PlaceOrderStepsController;

export {
  make ,
  
}
/* react Not a pure module */
